import { observeOnce, prefersReducedMotion } from '@kame/lib';

class KameCompare extends HTMLElement {
  connectedCallback() {
    if (prefersReducedMotion()) return;
    this.classList.add('is-armed');
    this.revealObserver = observeOnce(this, () => this.classList.add('is-inview'), '0px 0px -10% 0px');
  }

  disconnectedCallback() {
    this.revealObserver?.disconnect();
  }
}

if (!customElements.get('kame-compare')) customElements.define('kame-compare', KameCompare);
